<template>
	<div class='knd-tooltip' 
		v-show="showTooltip" 		
		v-bind:style="{ 'left': tooltipXpos +'px', 'top': tooltipYpos +'px'}"
	>
		<div class='knd-tooltip__container' ref='tooltip'>
			<slot></slot>
		</div>
	</div>

</template>

<script>
	import './tooltip.scss'

export default {

  name: 'tooltip',
  props: ['tooltip', 'showTooltip'],

  watch: {
    'tooltip': function (val, oldVal) {
		let padding = 15;
		let tooltipWidth = this.$refs.tooltip ? this.$refs.tooltip.offsetWidth : 0;

		this.tooltipYpos = val.y + padding;
		this.tooltipXpos = val.x - (tooltipWidth /2);

    }
  }

}
</script>

<style lang="css" scoped>
</style>